import Grid from "@material-ui/core/Grid";
import React, {useState} from "react";
import SingleValidPropositions from "./SingleValidPropositions";
import costumerServicePic from "./pictures/customer-service.svg"
import insurancePic from "./pictures/insurance.svg"
import bestPrice from "./pictures/best-price.svg"
import i18n from "../../../../i18nextInitiator";
import Divider from "../../Divider";

/**
 * The Specific translate function for this namespace
 * @type {TFunction}
 */
const t = i18n.getFixedT('fa', 'general');
/**
 * Displays valid propositions in pre invoice page
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const ValidPropositions = props => {
    /**
     * Number of the valid propositions shown in pre invoice page.
     * @type {number}
     */
    const [number] = useState([
            {
                key: "first",
                pic: costumerServicePic,
                title: t("valid-propositions.0")
            },
            // {
            //     key: "second",
            //     pic: insurancePic,
            //     title: t("valid-propositions.1")
            // },
            {
                key: "third",
                pic: bestPrice,
                title: t("valid-propositions.2")
            }
        ]
    );

    return <>
        <Grid item xs={12} style={{marginTop: 30}}>
            <Grid container justifyContent={"space-between"}>
                {
                    number.map((proposition) => {
                        return <SingleValidPropositions {...proposition}/>
                    })
                }
            </Grid>
        </Grid>
        <Divider/>
    </>
}
export default ValidPropositions